const adminRoutes = [
  {
    path: '/admin',
    name: 'Admin',
    redirect: '/admin/users',
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      layout: 'default'
    }
  },
  {
    path: '/admin/landing',
    name: 'LandingAdmin',
    component: () => import('../components/admin/LandingAdmin.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      layout: 'default'
    }
  },
  {
    path: '/admin/users',
    name: 'UserManagement',
    component: () => import('../components/admin/UserManagement.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      layout: 'default'
    }
  },
  {
    path: '/admin/api-management',
    name: 'ApiManagement',
    component: () => import('../components/admin/ApiManagement.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      layout: 'default'
    }
  },
  {
    path: '/admin/settings',
    name: 'AdminSettings',
    component: () => import('../components/admin/AdminSettings.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      layout: 'default'
    },
    redirect: '/admin/settings/asset-types',
    children: [
      {
        path: 'asset-types',
        name: 'AssetTypeManagement',
        component: () => import('../components/admin/AssetTypeManagement.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'assets',
        name: 'AssetManagement',
        component: () => import('../components/admin/AssetManagement.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'dividend-frequencies',
        name: 'DividendFrequencyManagement',
        component: () => import('../components/admin/DividendFrequencyManagement.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'currencies',
        name: 'CurrencyManagement',
        component: () => import('../components/admin/CurrencyManagement.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'markets',
        name: 'MarketManagement',
        component: () => import('../components/admin/MarketManagement.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      }
    ]
  }
]

export default adminRoutes
